import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';
//Importo o componente de conteudo
import Globals from './Components/Miscelania/Globals';

//Importo as views

// Users
import Login from './Components/Users/Login';
import RecuperarSenha from './Components/Users/RecuperarSenha';
import Suspenso from './Components/Users/Suspenso';
import UsersEditPassword from './Components/Users/UsersEditPassword';

// User
import UsersEdit from './Components/Users/UsersEdit';
import UsersIndex from './Components/Users/UsersIndex';
import UsersAdd from './Components/Users/UsersAdd';

// SIGTRIP
import SigtripUsersEdit from './Components/Sigtrip/SigtripUsersEdit';
import SigtripUsersIndex from './Components/Sigtrip/SigtripUsersIndex';
import SigtripUsersAdd from './Components/Sigtrip/SigtripUsersAdd';
import SigtripGroupsEdit from './Components/Sigtrip/SigtripGroupsEdit';
import SigtripGroupsIndex from './Components/Sigtrip/SigtripGroupsIndex';
import SigtripGroupsAdd from './Components/Sigtrip/SigtripGroupsAdd';
import SigtripLogsIndex from './Components/Sigtrip/SigtripLogsIndex';
import SigtripErrorsIndex from './Components/Sigtrip/SigtripErrorsIndex';
import SigtripVoeOmniLogs from './Components/Sigtrip/SigtripVoeOmniLogs';
import SigtripLogbookAppLogs from './Components/Sigtrip/SigtripLogbookAppLogs';
import SigtripAuditPermissions from './Components/Sigtrip/SigtripAuditPermissions';

// SIGMEC
import SigmecUsersEdit from './Components/Sigmec/SigmecUsersEdit';
import SigmecUsersIndex from './Components/Sigmec/SigmecUsersIndex';
import SigmecUsersAdd from './Components/Sigmec/SigmecUsersAdd';
import SigmecGroupsEdit from './Components/Sigmec/SigmecGroupsEdit';
import SigmecGroupsIndex from './Components/Sigmec/SigmecGroupsIndex';
import SigmecGroupsAdd from './Components/Sigmec/SigmecGroupsAdd';
import SigmecLogsIndex from './Components/Sigmec/SigmecLogsIndex';
import SigmecErrorsIndex from './Components/Sigmec/SigmecErrorsIndex';
import SigmecAuditPermissions from './Components/Sigmec/SigmecAuditPermissions';

// SIGMEC
import SigtreinUsersEdit from './Components/Sigtrein/SigtreinUsersEdit';
import SigtreinUsersIndex from './Components/Sigtrein/SigtreinUsersIndex';
import SigtreinUsersAdd from './Components/Sigtrein/SigtreinUsersAdd';
import SigtreinGroupsEdit from './Components/Sigtrein/SigtreinGroupsEdit';
import SigtreinGroupsIndex from './Components/Sigtrein/SigtreinGroupsIndex';
import SigtreinGroupsAdd from './Components/Sigtrein/SigtreinGroupsAdd';
import SigtreinLogsIndex from './Components/Sigtrein/SigtreinLogsIndex';
import SigtreinErrorsIndex from './Components/Sigtrein/SigtreinErrorsIndex';



class App extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      permission: false,
    }

  }
    componentDidMount() {
        var url_login = config.get('url') + '/usuario/login';
        var url_suspended = config.get('url') + '/usuario/suspenso';
        var url_recovery_pw = config.get('url') + '/usuario/recuperar_senha';
        var url_actual = window.location.href;

        if(url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw) {
          // busco as infos
          var params = JSON.parse(localStorage.getItem("cid"));
          // Verifico se há algum storage setado
          if(params === null || typeof params === 'undefined') {
            window.location.replace(config.get('url') + '/usuario/login');
          } else {
            // Verifico se o cid acode setado
            if(params.acode === null || typeof params.acode === 'undefined') {
              window.location.replace(config.get('url') + '/usuario/login');
            } else {
              this.setState({permission: true});
            }
          }
        } else {
          this.setState({permission: true});
        }
    }
  render() {
    return (
      <div>
        {
          (this.state.permission === false) ? '' :
            <div>
              <BrowserRouter>
                <Switch>
                  {/* User */}
                  <Route path="/usuario/login" component={Login} />
                  <Route path="/usuario/suspenso" component={Suspenso} />
                  <Route path="/usuario/editar/:id" component={UsersEdit} />
                  <Route path="/usuario/cadastrar" component={UsersAdd} />
                  <Route path="/usuarios" component={UsersIndex} />
                  {/* SIGTRIP */}
                  <Route path="/sigtrip/usuario/editar/:id" component={SigtripUsersEdit} />
                  <Route path="/sigtrip/usuario/cadastrar" component={SigtripUsersAdd} />
                  <Route path="/sigtrip/usuarios" component={SigtripUsersIndex} />
                  <Route path="/sigtrip/grupo/permissao/editar/:id" component={SigtripGroupsEdit} />
                  <Route path="/sigtrip/grupo/permissao/cadastrar" component={SigtripGroupsAdd} />
                  <Route path="/sigtrip/grupos/permissoes" component={SigtripGroupsIndex} />
                  <Route path="/sigtrip/logs" component={SigtripLogsIndex} />
                  <Route path="/sigtrip/log/erros" component={SigtripErrorsIndex} />
                  <Route path="/sigtrip/log/voeomni" component={SigtripVoeOmniLogs} />
                  <Route path="/sigtrip/log/logbookapp" component={SigtripLogbookAppLogs} />
                  <Route path="/sigtrip/auditoria/permissoes" component={SigtripAuditPermissions} />
                  {/* SIGMEC */}
                  <Route path="/sigmec/usuario/editar/:id" component={SigmecUsersEdit} />
                  <Route path="/sigmec/usuario/cadastrar" component={SigmecUsersAdd} />
                  <Route path="/sigmec/usuarios" component={SigmecUsersIndex} />
                  <Route path="/sigmec/grupo/permissao/editar/:id" component={SigmecGroupsEdit} />
                  <Route path="/sigmec/grupo/permissao/cadastrar" component={SigmecGroupsAdd} />
                  <Route path="/sigmec/grupos/permissoes" component={SigmecGroupsIndex} />
                  <Route path="/sigmec/logs" component={SigmecLogsIndex} />
                  <Route path="/sigmec/log/erros" component={SigmecErrorsIndex} />
                  <Route path="/sigmec/auditoria/permissoes" component={SigmecAuditPermissions} />
                  {/* SIGTREIN */}
                  <Route path="/sigtrein/usuario/editar/:id" component={SigtreinUsersEdit} />
                  <Route path="/sigtrein/usuario/cadastrar" component={SigtreinUsersAdd} />
                  <Route path="/sigtrein/usuarios" component={SigtreinUsersIndex} />
                  <Route path="/sigtrein/grupo/permissao/editar/:id" component={SigtreinGroupsEdit} />
                  <Route path="/sigtrein/grupo/permissao/cadastrar" component={SigtreinGroupsAdd} />
                  <Route path="/sigtrein/grupos/permissoes" component={SigtreinGroupsIndex} />
                  <Route path="/sigtrein/logs" component={SigtreinLogsIndex} />
                  <Route path="/sigtrein/log/erros" component={SigtreinErrorsIndex} />
                  {/* Home */}
                  <Route path="/" component={UsersIndex} />
                </Switch>
              </BrowserRouter>
            </div>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js